import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toaster-styles.css";
import { setSocketNotification } from "../components/AppSlice";
import { useDispatch } from "react-redux";

export default function Toaster(props) {
  const dispatch = useDispatch()
  const position = props?.isSocket ? 'bottom-right' : 'top-right';
  useEffect(() => {
    let timer;
    if (props?.isSocket) {
      timer = setTimeout(() => dispatch(setSocketNotification(false)), 2100)
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [props?.isSocket, dispatch])
  return <ToastContainer
    position={position}
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop={true}
    theme='light'
    closeOnClick={true}
    rtl={false}
    pauseOnFocusLoss={true}
    draggable={true}
    pauseOnHover={true}
    limit={5}
  />
};
